/**
 * Validates that userKey is present and valid before making API calls
 * @param {number|string} userKey - The user key to validate
 * @throws {Error} If userKey is invalid
 */
export function validateUserKey(userKey) {
  if (userKey === undefined || userKey === null || userKey === 0 || userKey === "0" || userKey === "") {
    throw new Error("User session not initialized. Please wait for authentication to complete.");
  }
  return true;
}
